import PageTour, { type TourStep } from './PageTour';

interface Props { hasTraining: boolean; onComplete: () => void }

function buildSteps(hasTraining: boolean): TourStep[] {
  const s: TourStep[] = [
    {
      title: 'Welcome to Attendza!', emoji: '👋', placement: 'center',
      body: "Let's take a 60-second tour — by the end you'll know exactly where to find everything.",
    },
    {
      target: '#tour-sidebar', title: 'Navigation Sidebar', emoji: '🧭', placement: 'right',
      body: 'Everything lives here. Jump between Home, Clock In, Time Off, Training and more from this panel.',
    },
    {
      target: '#tour-nav-clock-in', title: 'Clock In / Out', emoji: '⏱️', placement: 'right',
      body: 'Tap here to start or end your shift. The system records your hours automatically.',
    },
    {
      target: '#tour-nav-time-off', title: 'Time Off', emoji: '🏖️', placement: 'right',
      body: 'Request annual leave, sick days, or WFH. Your balance updates in real time.',
    },
  ];
  if (hasTraining) {
    s.push({
      target: '#tour-nav-training', title: 'Training & Learning', emoji: '📚', placement: 'right',
      body: 'Browse company courses, track your progress, and earn completions.',
    });
  }
  s.push(
    {
      target: '#tour-main-content', title: 'Your Dashboard', emoji: '📊', placement: 'left',
      body: 'This area shows the current section. Your home screen has attendance, leave balance, announcements and metrics.',
    },
    {
      target: '#tour-avatar', title: 'Profile & Account', emoji: '👤', placement: 'left',
      body: 'Click here for your profile, personal info, password, and sign-out.',
    },
    {
      title: "You're all set!", emoji: '🚀', placement: 'center',
      body: 'Each page has its own quick tour the first time you visit — just follow the highlights!',
    },
  );
  return s;
}

export default function TourOverlay({ hasTraining, onComplete }: Props) {
  return <PageTour steps={buildSteps(hasTraining)} onComplete={onComplete} />;
}
